import { EducationLevel } from './types';

export const educationLevelMap: Record<EducationLevel, string> = {
    fundamental_incompleto: 'Fundamental Incompleto',
    fundamental_completo: 'Fundamental Completo',
    medio_incompleto: 'Médio Incompleto',
    medio_completo: 'Médio Completo',
    superior_incompleto: 'Superior Incompleto',
    superior_completo: 'Superior Completo',
    pos_graduacao: 'Pós-Graduação',
};
